import React, { ReactElement } from 'react';
import { ErrorPageContainer, ErrorContentContainer, ErrorStyledIcon } from './styles';

export const ErrorPage = (props: { account: string | null }): ReactElement => {
  const { account } = props;

  const message = {
    'mygp.cz': 'Omlouváme se, došlo k chybě.',
    'mygp.sk': 'Prepáčte, vyskytla sa chyba.',
    'mygp.at': 'Wir bitten um Entschuldigung, es ist ein Fehler passiert.',
    'mygp.ro': 'Ne pare rău, a apărut o eroare.'
  };
  const defaultMessage = 'Sorry, an error has occurred.';

  const accounts = Object.keys(message);

  const errorText = account && accounts.includes(account) ? message[account] : defaultMessage;
  return (
    <ErrorPageContainer>
      <ErrorContentContainer>
        <div>
          <ErrorStyledIcon />
        </div>
        <p>{errorText}</p>
      </ErrorContentContainer>
    </ErrorPageContainer>
  );
};
